import News from "../../../models/common/News";
import Contact from "../../../models/common/Contact";
import Item from "../../../models/common/Item";
import custom from "../../../assets/img/partnerPortal/welcomePage/innovate.png";
import gartner_banner from "../../../assets/img/partnerPortal/welcomePage/gartner_banner.png";
import perform_banner from "../../../assets/img/partnerPortal/welcomePage/perform_banner.jpg";
import Banner from "../../../models/common/Banner";

// BANNER
export const TITLE = (
  <div>
    Welcome to your<br></br>Partner Portal
  </div>
);
export const ABOVE_TITLE = "PREMIER PARTNER";
export const BUTTON_NAME = "Register a deal";
export const BUTTON_LINK = "https://partners.dynatrace.com/#/page/sales";
// --

// BANNERS
const banner0: Banner = new Banner(
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_med[…]race&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  "_parent",
  "100%",
  gartner_banner
);
const banner1: Banner = new Banner(
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  "_parent",
  "100%",
  perform_banner
);
const banner2: Banner = new Banner(
  "https://www.dynatrace.com/innovate/?utm_medium=partner&utm_source=dynatrace&utm_campaign=innovate&utm_content=partner-portal&utm_term=25",
  "_parent",
  "100%",
  custom
);
export const ALL_BANNERS: Array<Banner> = new Array<Banner>(banner0, banner1);

// CONTACTS

const dynaContact1: Contact = new Contact(
  "Kerry Partridge",
  "Global Strategic Partner Director",
  "kerry.partridge@dynatrace.com",
  "Tel. +44 7920 233244"
);
const dynaContact6: Contact = new Contact(
  "Jill Head",
  "Global Strategic Partner Marketing",
  "jill.head@dynatrace.com",
  "Tel. +1 720-371-1357 "
);
const dynaContact2: Contact = new Contact(
  "Luis Porem",
  "VP, EMEA Partners",
  "luis.porem@dynatrace.com",
  "Tel. +351 965-060-497"
);
const dynaContact4: Contact = new Contact(
  "Alejandro Musgrove",
  "Senior Director LATAM Partners",
  "alejandro.musgrove@dynatrace.com",
  "Tel. +1 954-684-3117"
);
const dynaContact5: Contact = new Contact(
  "Alex Lim",
  "Senior Director APAC Partners",
  "alex.lim@dynatrace.com",
  "Tel. +65 833-959-68"
);
const contact_one: Contact = new Contact(
  "Russel Wilkinson",
  "Partner Cloud Evangelist(SE) - NORAM",
  "russel.wilkinson@dynatrace.com"
);
const contact_two: Contact = new Contact(
  "Rodrigo Pascoal",
  "Partner Cloud Evangelist(SE) - EMEA",
  "rodrigo.pascoal@dynatrace.com"
);
const contact_three: Contact = new Contact(
  "Steve Weinert",
  "Partner Cloud Evangelist(SE) - EMEA",
  "steve.weinert@dynatrace.com"
);
const contact_four: Contact = new Contact(
  "Nestor Zapata",
  "Partner Cloud Evangelist(SE) - LATAM",
  "nestor.zapata@dynatrace.com"
);
const countact_five: Contact = new Contact(
  "Jason Nai",
  "Partner Cloud Evangelist(SE) - APAC",
  "jason.nai@dynatrace.com"
);
export const ALL_DYNA_CONTACT_LIST: Array<Contact> = new Array<Contact>(
  dynaContact1,
  dynaContact6,
  dynaContact2,
  dynaContact4,
  dynaContact5,
  contact_one,
  contact_two,
  contact_three,
  contact_four,
  countact_five
);
// --

//PDR SECTION
const event0: News = new News(
  "Register a new deal",
  "https://partners.dynatrace.com/#/page/sales",
  false,
  true,
  true,
  "",
  "here"
);
export const CREATE_PDR: Array<News> = new Array<News>(event0);

// NEWS AND EVENTS
const news34: News = new News(
  "Perform and Innovate Sponsor Prospectus FY26",
  "https://partners.dynatrace.com/content/8a99822b95b0e7e80195b4734ee018f8",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news33: News = new News(
  "Watch Perform on-demand​",
  "https://www.dynatrace.com/perform/",
  true,
  true,
  true,
  undefined,
  "Watch now"
);
const news32: News = new News(
  "Dynatrace Introduces Observability for Developers​",
  "https://www.dynatrace.com/news/press-release/dynatrace-introduces-observability-for-developers/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news31: News = new News(
  "Dynatrace Partners with Visa Cash App Racing Bulls (VCARB) Formula One™ Team​",
  "https://www.dynatrace.com/news/press-release/dynatrace-partners-with-visa-cash-app-racing-bulls-vcarb-formula-one-team-as-official-observability-performance-analytics-technology-partner/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news30: News = new News(
  "Credit Saison accelerates its IT observability with Dynatrace and Kyndryl​",
  "https://partners.dynatrace.com/#/collateral/8a998aa691708cb301917550dd5f0c6a",
  false,
  true,
  true
);
const news29: News = new News(
  "Streaming event: Dynatrace & the Power of Possible​",
  "https://webinars.techstronglearning.com/dynatrace-and-the-power-of-possible?utm_medium=partner&utm_source=dynatrace&utm_campaign=virtual-event&utm_content=portal&utm_term=q3fy25",
  false,
  true,
  true
);
const news28: News = new News(
  "Partners lead with Dynatrace SaaS​",
  "https://partners.dynatrace.com/#/collateral/8a9983ce90d6f9a50190f221a5f121bd",
  false,
  true,
  true
);
const news26: News = new News(
  "Dynatrace named a Leader in the 2024 Gartner® Magic Quadrant™ for Observability Platforms​",
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_medium=partner&utm_source=dynatrace&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  false,
  true,
  true
);
export const ALL_EVENTS_LIST: Array<News> = new Array<News>(
  news34,
  news33,
  news32,
  news31,
  news30,
  news29,
  news28
);

// ITEMS
const item1: Item = new Item(
  "Dynatrace ranked #1 in 6 of 6 Use Cases in 2023 Gartner® Critical Capabilities for APM and Observability report.",
  "Read more",
  "https://www.dynatrace.com/gartner-critical-capabilities-for-application-performance-monitoring-observability/"
);
const item2: Item = new Item(
  "Dynatrace named a Leader in the 2023 Gartner MQ for APM & Observability ",
  "Read more",
  "https://www.dynatrace.com/monitoring/gartner-magic-quadrant-for-application-performance-monitoring-observability/"
);
const item3: Item = new Item(
  "Forrester Wave: Dynatrace named a Leader in AIOps ",
  "Read more",
  "https://www.dynatrace.com/info/reports/forrester-aiops-wave-report/"
);
export const ALL_ITEMS_LIST: Array<Item> = new Array<Item>(item1, item2, item3);

// TOOLS
const tool1: Item = new Item(
  "US:  Kyndryl and Dynatrace Announce Global Alliance ",
  "View source",
  "https://www.kyndryl.com/in/en/about-us/news/2023/11/aiops-partnership-with-dynatrace"
);
const tool2: Item = new Item(
  "Europe: Kyndryl and Dynatrace go to market on observability ",
  "View source",
  "https://www.iteuropa.com/news/kyndryl-and-dynatrace-go-market-observability"
);
const tool3: Item = new Item(
  "India:  Dynatrace & Kyndryl Form a Partnership to Amplify Business Potential ",
  "View source",
  "https://analyticsindiamag.com/dynatrace-kyndryl-form-a-partnership-to-amplify-business-potential/"
);
export const ALL_TOOLS_LIST: Array<Item> = new Array<Item>(tool1, tool2, tool3);
